/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Zurück',
    BACK_TO_SEARCH: 'Zurück zur Suche',
    CANCEL: 'Abbrechen',
    CANCEL_DELIVERY_REQUEST: 'Anfrage abbrechen',
    CHANGE_DAY: 'Tag ändern',
    CHANGE_LOCATION: 'Standort ändern',
    CLICK_TO_EXPAND: 'Zum Erweitern klicken oder wischen',
    COLLECT_PIN: 'Abholcode',
    CONFIRM: 'Bestätigen',
    CURRENT_LOCATION: 'Aktuellen Standort verwenden',
    EDIT_PIN: 'Standort-Pin bearbeiten',
    HELP_US_IMPROVE: 'Hilf uns, uns zu verbessern',
    LEAVE: 'verlassen',
    NEW_SEARCH: 'Neue Suche',
    PICK_UP_PIN: 'Abholcode',
    PICK_UP_POINT: 'Abholstelle',
    SAME_LOCATION: 'Gleicher Standort',
    SCAN_QR_CODE: 'QR-Code lesen',
    SEARCH: 'Suchen',
    SIGN_IN: 'Anmelden, um die Lieferanforderung zu ändern',
    SIGN_IN_FOR_EVALUATION: 'Anmelden, um uns zu helfen uns zu verbessern',
    SWIPE_DOWN: 'Nach unten wischen, um die Details auszublenden',
    SWIPE_UP: 'Nach oben wischen, um die Details anzuzeigen'
  },
  ERRORS: {
    SERVICE_POINT_DOES_NOT_ACCEPT_COLLECTS:
      'Die Servicestelle akzeptiert keine Selbstabholung!',
    SERVICE_POINT_DOES_NOT_ACCEPT_ICE:
      'Die Servicestelle nimmt keine Bestellungen mit Eisboxen entgegen!',
    SERVICE_POINT_DOES_NOT_HAVE_CAPACITY:
      'Die Servicestelle hat die maximale Bestellkapazität erreicht!',
    SOMETHING_WENT_WRONG:
      'Etwas ist schief gelaufen, bitte versuche es später erneut.',
    ZIP_CODE_WRONG_FORMAT: 'Ungültiges Postleitzahlenformat'
  },
  LABELS: {
    CURRENT: 'von',
    DELETE_MESSAGE: 'Mitteilung löschen',
    ERROR: 'Fehler',
    NEW: 'an',
    NEW_ADDRESS: 'Neue Adresse',
    OR: 'Oder',
    ORIGINAL_ADDRESS: 'Ursprüngliche Adresse',
    PICK_UP_POINT: 'Abholstelle',
    REQUIRES_CONFIRMATION: 'Die Änderung erfordert eine Bestätigung',
    SAME_DAY_COLLECT: 'Abholung am selben Tag',
    SAME_DAY_DELIVERY: 'Lieferung am selben Tag',
    SCHEDULE: 'Zeitplan',
    SEARCH_LOCATION: 'Adresse suchen'
  },
  MESSAGES: {
    ADICIONAL_ADDRESS: 'Adresszusatz',
    ADJUST_PIN: 'Standort-Pin anpassen',
    BUILDING_DOOR_NUMBER: 'Gebäude-/Tür-Nr.',
    CALL_US: 'Ruf uns an',
    CHANGE_ADDRESS: 'Adresse ändern',
    CHANGE_ADDRESS_AUTOMATIC_COLLECT:
      'Die Adresse der Abholanfrage wurde geändert.',
    CHANGE_ADDRESS_AUTOMATIC_DELIVERY:
      'Die Adresse der Lieferanfrage wurde geändert.',
    CHANGE_ADDRESS_TO_PICK_UP: 'Adresse zum Abholort ändern',
    CHANGE_COLLECT: 'Abholung ändern',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_COLLECT:
      'Das Datum und die Adresse der Abholanfrage wurden geändert.',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_DELIVERY:
      'Das Lieferdatum und die Adresse der Bestellung wurden geändert.',
    CHANGE_DATE_AUTOMATIC_COLLECT: 'Das Datum der Abholanfrage wurde geändert.',
    CHANGE_DATE_AUTOMATIC_DELIVERY: 'Das Lieferauftragsdatum wurde geändert.',
    CHANGE_DAY: 'Tag ändern',
    CHANGE_DELIVERY: 'Lieferung ändern',
    CHAT_TITLE: 'Mitteilungen',
    CITY: 'Stadt',
    CLIENT_REQUEST_TYPE: 'Anforderungstyp',
    CONFIRM_DELETE_MESSAGE: 'Möchtest du diese Mitteilung wirklich löschen?',
    CURRENT_COORDINATES: 'Aktuelle Koordinaten',
    CUSTOMER_SUPPORT: 'Kundendienst',
    DATE: 'Datum',
    DELETE_MESSAGE_NOW_ERROR:
      'Die Mitteilung kann nicht gelöscht werden, da sie bereits von NOW gelesen wurde.',
    DELETED_MESSAGE: 'Diese Mitteilung wurde gelöscht',
    DELIVERY_HISTORY: 'Verlauf',
    DETAIL: 'Details',
    DOOR_NUMBER: 'Tür-Nr.',
    FILL_SEARCH_FIELDS:
      'Bitte ausfüllen: Straße, Hausnummer, Postleitzahl und Ort.',
    FROM: 'Von:',
    HOUR: 'Stunde',
    INVALID_TRACKING: 'Ungültige Tracking-Nummer',
    LOCATION_PREFERENCE: 'Standortpräferenz',
    MANDATORY_FIELD: 'Pflichtfeld.',
    MAX_CHARACTERS: 'Max. {max} Zeichen.',
    MESSAGE: 'Nachricht',
    MESSAGES: 'Mitteilungen',
    NEW_MESSAGE: 'Neue Mitteilung',
    OBSERVATIONS: 'Beobachtungen',
    REQUEST_APROVED: 'Anfrage akzeptiert',
    REQUEST_CANCEL_TITLE: 'Anfrage abbrechen',
    REQUEST_CHANGE_ADDRESS: 'Anfrage zum Ändern der Adresse',
    REQUEST_CHANGE_DATE: 'Anfrage zum Ändern des Datums',
    REQUEST_CHANGE_DATE_AND_ADDRESS: 'Anfrage zum Ändern von Datum und Adresse',
    REQUEST_CONTACT: 'Kontaktanfrage',
    REQUEST_CONTACT_TITLE: 'Kontaktanfrage',
    REQUEST_MESSAGE: 'Nachrichtenanfrage',
    REQUEST_REJECTED: 'Anfrage abgelehnt',
    SEARCH_ADDRESS: 'Adresse suchen',
    SEND_MESSAGE: 'Neue Mitteilung',
    STATUS: 'Status',
    STATUS_CANCELED: 'Storniert',
    STATUS_PENDING_TREATMENT: 'Ausstehend',
    STATUS_REJECTED: 'Abgelehnt',
    STATUS_TREATED: 'Genehmigt',
    STREET: 'Straße',
    TO: 'Für:',
    TYPE_MESSAGE: 'Gib deine Nachricht ein...',
    ZIP_CODE: 'Postleitzahl'
  },
  SENTENCES: {
    ADDRESS_NOT_FOUND:
      'Es wurde keine Adresse gefunden 😞. Bitte versuche es erneut.',
    CONFIRM_CHANGE:
      'Deine Anfrage wurde erfolgreich gesendet. Wir analysieren den besten Weg, um dir zu helfen 🙂.',
    CONFIRM_CHANGE_AUTOMATIC: 'Deine Anfrage wurde erfolgreich akzeptiert 🙂.',
    CONFIRM_ERROR:
      'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.',
    COORDINATES_NOT_FOUND:
      'Keine Koordinaten für die gewählte Adresse gefunden.',
    DELIVERY_REQUEST_FAIL: 'Fehler beim Abbrechen der Anfrage!',
    INVALID_DESTINATION: 'Ungültige Zieladresse!',
    MAXIMUM_CONTACT_REQUESTS:
      'Du kannst maximal {total} Kontaktanfragen stellen.',
    MAXIMUM_REACHED: 'Die maximale Anzahl an Anfragen wurde erreicht!',
    MAXIMUM_REQUESTS: 'Du kannst maximal {total} Änderungsanträge stellen.',
    MAXIMUM_REQUESTS_LEFT: 'Es fehlen {left}.',
    NOT_FOUND: 'Leider konnten wir nicht finden, wonach du suchst.',
    NUMBER_OF_PACKAGES: '(bestehend aus {total} Kisten)',
    OUT_OF_RANGE:
      'Die Adresse, zu der du wechseln möchtest, liegt außerhalb des Bereichs unseres NOW. Um diese Änderung vorzunehmen, wende dich bitte an unseren {support}.',
    PICK_UP_NOT_FOUND:
      'Es konnte keine Abholstelle gefunden werden 😞, bitte versuche es erneut.',
    REQUEST_CANCEL_DESCRIPTION:
      'Bist du sicher, dass du die Änderungsanforderung abbrechen möchtest?',
    REQUEST_CHANGE_APPROVED: 'Dein {type} wurde akzeptiert.',
    REQUEST_CHANGE_REJECTED: 'Dein {type} wurde nicht akzeptiert.',
    REQUEST_CONTACT_APPROVED: 'Wir werden auf deine {type} antworten.',
    REQUEST_CONTACT_DESCRIPTION:
      'Nach der Bestätigung werden wir uns so bald wie möglich mit dir in Verbindung setzen 🙂.',
    REQUEST_CONTACT_EVALUATION:
      'Es gibt eine ausstehende Kontaktanfrage. Wir werden uns bald mit dir in Verbindung setzen. Vielen Dank.',
    REQUEST_CONTACT_REJECTED:
      'Es ist nicht möglich, auf deine {type} zu antworten.',
    REQUEST_CONTACT_SUBMITTED:
      'Deine Anfrage wurde erfolgreich eingereicht. Du wirst so schnell wie möglich von jemandem von PROZIS NOW kontaktiert werden 🙂.',
    SHOW_COLLECT_QR_CODE:
      'Zeige diesen Code an der Abholstelle vor, damit du die abzuholende Ware liefern kannst.',
    SHOW_DELIVERY_QR_CODE:
      'Zeige diesen Code an der Abholstelle vor, um deine Bestellung abzuholen.',
    STATUS_COLLECT_FAKE_PROCESSING:
      'Dein Abholantrag wird bis zum {date} bearbeitet. Danke 😉.',
    STATUS_COLLECT_IN_INTERRUPTED_ROUTE:
      'die Route ist derzeit aufgrund technischer Probleme unterbrochen, deine Anfrage wird so schnell wie möglich fortgesetzt.',
    STATUS_COLLECT_IN_ROUTING:
      'Wir sind bereits unterwegs und deine Abholanfrage wird zwischen {from} und {to} von {driver} ausgeführt. Es ist fast soweit 😉.',
    STATUS_COLLECT_IN_SERVICE_POINT:
      'Wir warten darauf, dass du bei {name} hinterlegst, was wir abholen sollen.',
    STATUS_COLLECT_ON_THE_WAY_TO_SERVICE_POINT:
      'Wir sind bereits unterwegs und deine Abholanfrage wird zwischen {from} und {to} von {driver} an der Abholstelle {name} ausgeführt. Es ist fast soweit 😉.',
    STATUS_COLLECT_PROCESSING:
      'Deine Abholanfrage wurde bereits am {date} um {hour} bearbeitet. Es dauert nicht mehr lange 😉.',
    STATUS_COLLECT_SUCCESS:
      'Deine Bestellung wurde bereits am {date} um {hour} von {driver} abgeholt. Wenn etwas nicht stimmt, kontaktiere {support}.',
    STATUS_COLLECT_UNSUCCESS: '{driver} konnte deine Bestellung nicht abholen.',
    STATUS_COLLECTED_SERVICE_POINT:
      'Deine Bestellung wurde am {date} um {hour} bei {pickUp} abgeholt.',
    STATUS_DELIVERED_SERVICE_POINT:
      'Deine Bestellung {packages} wurde am {date} um {hour} an der Abholstelle {pickUp} abgeholt.',
    STATUS_DELIVERY_FAKE_PROCESSING:
      'Deine Bestellung wird bis zum {date} bearbeitet. Danke 😉.',
    STATUS_DELIVERY_IN_INTERRUPTED_ROUTE:
      'die Route ist derzeit aufgrund technischer Probleme unterbrochen, deine Anfrage wird so schnell wie möglich fortgesetzt.',
    STATUS_DELIVERY_IN_ROUTING:
      'deine Bestellung {packages} ist bereits auf dem Weg und wird von {driver} zwischen {from} und {to} geliefert. Sie ist fast da 😉.',
    STATUS_DELIVERY_IN_SERVICE_POINT:
      'Deine Bestellung {packages} steht an der Abholstelle {name} zur Abholung bereit.',
    STATUS_DELIVERY_IN_SERVICE_POINT_UNTIL:
      'Du hast bis zum {date} Zeit, deine Bestellung {packages} abzuholen.',
    STATUS_DELIVERY_ON_THE_WAY_TO_SERVICE_POINT:
      'Deine Bestellung {packages} ist bereits unterwegs und wird zwischen {from} und {to} von {driver} an die Abholstelle {name} geliefert. Es ist fast soweit 😉.',
    STATUS_DELIVERY_PROCESSING:
      'Deine Bestellung {packages} wurde bereits am {date} um {hour} bearbeitet und befindet sich im Distributionszentrum {location}. Es ist fast soweit 😉.',
    STATUS_DELIVERY_SUCCESS:
      'Deine Bestellung {packages} wurde von {driver} bereits am {date} um {hour} geliefert. Wenn etwas nicht stimmt, {support}.',
    STATUS_DELIVERY_UNSUCCESS: '{driver} konnte die Bestellung nicht liefern.',
    STATUS_HELLO: ' 👋 Hallo {name},',
    UPDATING_CHANGE: 'Wir aktualisieren deine Anfrage 🙂',
    WARNING_DELIVERY_DELAY:
      'Hinwei: Es gibt eine Lieferverzögerung. Wende dich für weitere Informationen bitte an {support}.',
    WARNING_REDUCED_EXPIRATION_DATE:
      'Hinweis: Diese Bestellung enthält einen oder mehrere Artikel mit verkürzter Haltbarkeit, die am {date} abläuft. Möchtest du fortfahren?'
  }
};
